import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossTopLevelSearch from "@saleor/hooks/makeBossTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchPayoutMalls,
  SearchPayoutMallsVariables
} from "./types/SearchPayoutMalls";

export const searchPayoutMalls = gql`
  ${pageInfoFragment}
  query SearchPayoutMalls(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $query: String!
    $settlementStatus: SettlementStatusEnum
  ) {
    search: payoutMalls(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: { search: $query, settlementStatus: $settlementStatus }
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeBossTopLevelSearch<
  SearchPayoutMalls,
  SearchPayoutMallsVariables
>(searchPayoutMalls);
